import classnames from "classnames"
import type { ReactNode } from "react"

import styles from "./credit_meter.module.scss"

interface Props {
  filled: number
  onDark?: boolean
  children: ReactNode
}

const CreditMeter = ({ filled, onDark = false, children }: Props) => (
  <div className={classnames(styles["credit-meter"], { [styles["on-dark"]]: onDark })}>
    <div className={styles.indicator}>
      <div className={styles.fill} style={{ width: `${filled}%` }} />
    </div>
    {children}
  </div>
)

export default CreditMeter
